import { useQuery } from 'convex/react';
import { api } from '../../convex/_generated/api';

export function useLeaderboard() {
  const data = useQuery(api.coach.leaderboards.list);
  return { data: data ?? [], isLoading: data === undefined };
}
